module.exports = __webpack_public_path__ + "static/cubepipes-4e64592ec17ad10c9d07440d630a8edc.mp4";